import { pxToRem } from "@/utils";
// Sizes for typography scale

export const sizes = {
  xs: pxToRem(12),
  sm: pxToRem(14),
  base: pxToRem(16),
  lg: pxToRem(20),
  xl: pxToRem(22),
  xxl: pxToRem(28),
  xxxl: pxToRem(34),
};

export const fonts = {
  regular: 'Montserrat Regular',
  medium: 'Montserrat Medium',
  semiBold: 'Montserrat SemiBold',
  bold: 'Montserrat Bold',
};

export const DisplayLargeStyles = {
  fontFamily: `${fonts.semiBold} !important`,
  fontSize: `${sizes.xxxl}`,
  fontWeight: '600',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.21',
  letterSpacing: '-0.9px',
};

export const TitleLargeEmphasizedStyles = {
  fontFamily: `${fonts.bold} !important`,
  fontSize: `${sizes.xxl}`,
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.21',
  letterSpacing: '-0.6px',
};

export const TitleLargeStyles = {
  fontFamily: `${fonts.regular} !important`,
  fontSize: `${sizes.xxl}`,
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.21',
  letterSpacing: '-0.6px',
};

export const TitleMediumEmphasizedStyles = {
  fontFamily: `${fonts.bold} !important`,
  fontSize: `${sizes.xl}`,
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.27',
  letterSpacing: '-0.6px',
};

export const TitleMediumStyles = {
  fontFamily: `${fonts.regular} !important`,
  fontSize: `${sizes.xl}`,
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.27',
  letterSpacing: '-0.6px',
};

export const TitleSmallEmphasizedStyles = {
  fontFamily: `${fonts.bold} !important`,
  fontSize: `${sizes.lg}`,
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.25',
  letterSpacing: '-0.4px',
};

export const TitleSmallStyles = {
  fontFamily: `${fonts.regular} !important`,
  fontSize: `${sizes.lg}`,
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.25',
  letterSpacing: '-0.4px',
};

export const BodyLargeEmphasizedStyles = {
  fontFamily: `${fonts.bold} !important`,
  fontSize: `${sizes.base}`,
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: '-0.5px',
};

export const BodyLargeMidEmphasisdStyles = {
  fontFamily: `${fonts.medium} !important`,
  fontSize: `${sizes.base}`,
  fontWeight: '500',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: '-0.5px',
};

export const BodyLargeStyles = {
  fontFamily: `${fonts.regular} !important`,
  fontSize: `${sizes.base}`,
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.5',
  letterSpacing: '-0.5px',
};

export const BodyMediumEmphasizedStyles = {
  fontFamily: `${fonts.bold} !important`,
  fontSize: `${sizes.sm}`,
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.43',
  letterSpacing: '-0.4px',
};

export const BodyMediumMidEmphasisStyles = {
  fontFamily: `${fonts.medium} !important`,
  fontSize: `${sizes.sm}`,
  fontWeight: '500',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.43',
  letterSpacing: '-0.4px',
};

export const BodyMediumMidEmphasisUnderlineStyles = {
  fontFamily: `${fonts.medium} !important`,
  fontSize: `${sizes.sm}`,
  textDecoration: 'underline !important',
  fontWeight: '500',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.43',
  letterSpacing: '-0.4px',
  cursor: 'pointer',
};

export const BodyMediumStyles = {
  fontFamily: `${fonts.regular} !important`,
  fontSize: `${sizes.sm}`,
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.43',
  letterSpacing: '-0.4px',
};

export const BodySmallEmphasizedStyles = {
  fontFamily: `${fonts.bold} !important`,
  fontSize: `${sizes.xs}`,
  fontWeight: 'bold',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.33',
  letterSpacing: '-0.3px',
};

export const BodySmallMidEmphasisStyles = {
  fontFamily: `${fonts.medium} !important`,
  fontSize: `${sizes.xs}`,
  fontWeight: '500',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.33',
  letterSpacing: '-0.3px',
};

export const BodySmallMidEmphasisUnderlineStyles = {
  fontFamily: `${fonts.medium} !important`,
  fontSize: `${sizes.xs}`,
  fontWeight: '500',
  textDecoration: 'underline !important',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.33',
  letterSpacing: '-0.3px',
};

export const BodySmallStyles = {
  fontFamily: `${fonts.regular} !important`,
  fontSize: `${sizes.xs}`,
  fontWeight: 'normal',
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: '1.33',
  letterSpacing: '-0.3px',
};
